import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from 'lucide-react';

const PronounSelector = ({ selectedPronouns, onPronounsChange, isDisabled = false, size = 'default' }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  const options = [
    { value: 'He/him', label: 'He/him' },
    { value: 'She/her', label: 'She/her' },
    { value: 'They/them', label: 'They/them' }
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Determine sizing classes based on size prop
  const buttonClasses = size === 'small' 
    ? 'px-2 py-1 text-sm' 
    : 'px-3 py-2';

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <button
        onClick={() => !isDisabled && setIsOpen(!isOpen)}
        className={`flex items-center justify-between w-full ${buttonClasses} text-left border 
          rounded-lg bg-white hover:bg-gray-50 text-gray-700
          ${isDisabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}
          ${!selectedPronouns ? 'text-gray-400' : 'text-gray-700'}`}
        disabled={isDisabled}
      >
        <span>{selectedPronouns || 'Select pronouns'}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'transform rotate-180' : ''}`} />
      </button>
      
      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border rounded-lg shadow-lg">
          <div className="py-1">
            <div className="px-3 py-2 text-sm text-gray-400">
              Select pronouns
            </div>
            {options.map((option) => (
              <button
                key={option.value}
                onClick={() => {
                  onPronounsChange(option.value);
                  setIsOpen(false);
                }}
                className={`flex items-center justify-between w-full px-3 py-2 text-left hover:bg-gray-100 ${
                  selectedPronouns === option.value ? 'bg-gray-100' : ''
                }`}
              >
                <span>{option.label}</span>
                {selectedPronouns === option.value && (
                  <Check className="w-4 h-4 text-teal-600" />
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PronounSelector;